import {createTheme} from "@mui/material";
import {GridRenderCellParams} from "@mui/x-data-grid";
import React from "react";

export const theme = createTheme({
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    fontSize: '1.075rem',
                    border: 'none',
                    classes: "text-gray-600"
                },
                cell: {
                    ":focus": {outline: 'none'},
                    ":focus-within": {outline: 'none'}
                },
                columnHeaderTitle: {
                    color: '#7E8299' // "text-gray-800",
                },
                columnHeader: {
                    ":focus": {outline: 'none'},
                    ":focus-within": {outline: 'none'}
                },
                iconSeparator: {
                    display: 'none'
                },
                columnHeaderTitleContainer: {
                    padding: 0
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#B5B5C3'
                }
            }
        }
    },
});

const getNameLink = (params: GridRenderCellParams) => {
    return <span className="pseudoLink">{params.row.name}</span>
}

export const getColumns = () => [
    {
        field: 'name',
        headerName: 'Наименование',
        width: 200,
        renderCell: getNameLink,
    },
    {
        field: 'device_brand',
        headerName: 'Марка',
        width: 145
    },
    {
        field: 'device_model',
        headerName: 'Модель',
        width: 200
    },
    // {
    //     field: 'generation',
    //     headerName: 'Поддержка xG',
    //     width: 200
    // },
    {
        field: 'descr',
        headerName: 'Описание',
        width: 200
    }
]
